import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

const StatCard = ({ label, value, color }) => (
  <div style={{ background: color || '#E6F1FB', borderRadius: '10px', padding: '16px 20px' }}>
    <div style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>{label}</div>
    <div style={{ fontSize: '28px', fontWeight: '700', color: '#0C447C' }}>{value}</div>
  </div>
);

export default function DashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get('/api/dashboard').then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);
  if (loading) return <Layout><div style={{textAlign:'center',padding:'60px',color:'#888'}}>Loading...</div></Layout>;
  return (
    <Layout>
      <div style={{marginBottom:'20px'}}>
        <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>Dashboard</h1>
        <p style={{color:'#888',fontSize:'13px',marginTop:'4px'}}>Live overview of your warehouse</p>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'12px',marginBottom:'20px'}}>
        <StatCard label="Items out" value={data?.totals?.items_out||0} />
        <StatCard label="Overdue" value={data?.totals?.overdue||0} color="#FCEBEB" />
        <StatCard label="Pending approvals" value={data?.totals?.pending_approvals||0} color="#FAEEDA" />
        <StatCard label="Available" value={data?.totals?.available_total||0} color="#EAF3DE" />
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px'}}>
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'1px solid #eee'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Overdue items</h2>
          {!data?.overdueItems?.length ? <p style={{color:'#3B6D11',fontSize:'13px'}}>No overdue items</p>
            : data.overdueItems.map((item,i) => (
            <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
              <span>{item.item_name} — {item.first_name} {item.last_name}</span>
              <span style={{color:'#A32D2D',fontWeight:'600'}}>{Math.floor(item.hours_overdue/24)}d overdue</span>
            </div>
          ))}
        </div>
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'1px solid #eee'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Active job sites</h2>
          {!data?.sites?.length ? <p style={{color:'#888',fontSize:'13px'}}>No active sites</p>
            : data.sites.map((site,i) => (
            <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
              <div>
                <div style={{fontWeight:'600',color:'#333'}}>{site.name}</div>
                <div style={{color:'#888',fontSize:'11px'}}>{site.fo_first ? `Foreman: ${site.fo_first} ${site.fo_last}` : 'No foreman'}</div>
              </div>
              <div style={{textAlign:'right'}}>
                <div style={{color:'#185FA5'}}>{site.items_out} out</div>
                {site.overdue>0 && <div style={{color:'#A32D2D',fontSize:'11px'}}>{site.overdue} overdue</div>}
              </div>
            </div>
          ))}
        </div>
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'1px solid #eee'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Low stock</h2>
          {!data?.lowStock?.length ? <p style={{color:'#3B6D11',fontSize:'13px'}}>All items well stocked</p>
            : data.lowStock.map((item,i) => (
            <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
              <span>{item.name}</span>
              <span style={{color:'#854F0B',fontWeight:'600'}}>{item.available} left</span>
            </div>
          ))}
        </div>
        <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'1px solid #eee'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Category utilization</h2>
          {data?.utilization?.map((cat,i) => (
            <div key={i} style={{marginBottom:'10px'}}>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',marginBottom:'4px'}}>
                <span style={{color:'#555',textTransform:'capitalize'}}>{cat.category?.replace(/_/g,' ')}</span>
                <span style={{color:'#185FA5'}}>{cat.total>0?Math.round((cat.out/cat.total)*100):0}%</span>
              </div>
              <div style={{background:'#f0f0f0',borderRadius:'4px',height:'6px'}}>
                <div style={{background:'#185FA5',borderRadius:'4px',height:'6px',width:`${cat.total>0?Math.round((cat.out/cat.total)*100):0}%`}} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
